var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"building-equipment",class:{visible: _vm.visible},style:(_vm.styles)},[_c('vue-custom-scrollbar',[_c('container-type'),_c('container-info'),_c('container-items')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }